module.exports = __webpack_public_path__ + "img/whl (3).58cd1e55.png";